import {useEffect, useRef} from 'react';
import {pages} from './content';

export default function StaticPage({page=''}) {
  const root = useRef(null);
  const content = pages[page];
  useEffect(() => {
    document.title = content.title;
    const node = root.current;
    const button = node.querySelector('.menu-toggle');
    const nav = node.querySelector('#navigation');
    const close = () => { nav?.classList.remove('open'); button?.setAttribute('aria-expanded','false'); if(button) button.textContent='Menu'; };
    const toggle = () => { const open = button.getAttribute('aria-expanded') !== 'true'; nav?.classList.toggle('open',open); button.setAttribute('aria-expanded',String(open)); button.textContent=open?'Close':'Menu'; };
    const escape = e => { if(e.key==='Escape' && button?.getAttribute('aria-expanded')==='true') { close(); button.focus(); } };
    button?.addEventListener('click',toggle);
    nav?.addEventListener('click',close);
    document.addEventListener('keydown',escape);
    const year=node.querySelector('#year'); if(year) year.textContent=String(new Date().getFullYear());
    return () => { button?.removeEventListener('click',toggle); nav?.removeEventListener('click',close); document.removeEventListener('keydown',escape); };
  },[content]);
  // The only HTML rendered here is the reviewed source file checked into this repository.
  return <div className={page ? 'inner-page' : ''} ref={root} dangerouslySetInnerHTML={{__html:content.html}} />;
}
